import { useApi } from 'api/api-context';
import { DataSelect, DataSelectInheritedProps } from 'components/selects/DataSelect';
import { useCallback } from 'react';

interface HrLinkedUserSelectOption {
  value: number;
  label: string;
  group?: string;
}

/** Authoritative linked-user selector derived from accessible HR person relationships. */
export default function HrLinkedUserSelect(props: DataSelectInheritedProps) {
  const { getAction } = useApi();
  const fetchLinkedUsers = useCallback(async (): Promise<HrLinkedUserSelectOption[]> => {
    const people = await getAction('HrListPeople')({ query: { filters: { includeInactive: true } } });
    const users = new Map<number, HrLinkedUserSelectOption>();
    people.forEach((person) => {
      if (person.userId && person.userFullName) {
        users.set(person.userId, {
          value: person.userId,
          label: person.userFullName,
          group: person.organizationName,
        });
      }
    });
    return Array.from(users.values());
  }, [getAction]);

  return <DataSelect action={fetchLinkedUsers} valueProp="value" labelProp="label" groupProp="group" {...props} />;
}
